<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-activities">
  <div class="consumer-activities--layout">
    <app-consumer-sidebar class="consumer-activities--sidebar"></app-consumer-sidebar>
    <div class="consumer-activities--content">
      <app-page-header></app-page-header>
      <app-activities [showTabs]="true" [hideUsecaseFilter]="true" [consumerActivityFilter]="true"></app-activities>
    </div>
  </div>
</div>
